module.exports = __webpack_public_path__ + "af7505d8fe74901df91ee2c292165e08.MP3";